import { RouterProvider } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { BrandProvider } from '@/brand/BrandProvider'
import { AuthProvider } from '@/contexts/AuthContext'
import { router } from '@/router'

export default function App() {
  return (
    <BrandProvider>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster />
      </AuthProvider>
    </BrandProvider>
  )
}
